// Centralized branding and marketing copy for easy updates
export const SITE_NAME = 'BharatBill';
export const SITE_TAGLINE = 'GST-ready invoicing and client payments in INR';
export const SITE_DESCRIPTION = 'Simple, fast, and compliant invoicing in INR—made for Indian businesses with GST, UPI, and a client portal.';

export const BADGES = ['GST-ready', 'UPI payments', 'Client portal'];

export const HERO_BULLETS = [
  'Track invoices in INR',
  'Record payments (incl. UPI/UTR)',
  'Client approvals & history',
  'Multiple PDF templates'
];

export const FEATURES = [
  { title: 'GST-ready PDFs', desc: 'Multiple templates with GSTIN/Tax ID, payment history, and balance due.' },
  { title: 'Client portal', desc: 'Clients view invoices, submit payments, and track status.' },
  { title: 'Payments & UPI', desc: 'Record payments, capture UPI/UTR transaction IDs, and track balances.' },
  { title: 'Products & rates', desc: 'Save line items and apply them quickly while creating invoices.' },
  { title: 'Analytics & tracking', desc: 'Totals, paid vs due, and filters by month or company.' },
  { title: 'Made for India', desc: 'INR currency, Indian date formats, and local-friendly UX.' }
];

export const FAQS = [
  { q: 'Is it really INR-first?', a: 'Yes. Currency, formatting, and workflows are tuned for Indian businesses.' },
  { q: 'Can I include my GSTIN?', a: 'Absolutely. Add GSTIN/Tax ID in Settings and it shows on PDFs and invoice detail.' },
  { q: 'Do clients need accounts?', a: 'Clients get credentials from your business and can view invoices and submit payments.' },
  { q: 'Are PDFs customizable?', a: 'Choose from multiple templates when generating the invoice PDF.' }
];
